import { IDataUrlPost } from "../../../../utils";
import DataTable, { IColumn } from "../../../data-table/data-table";

export interface ITableWidget {
  id: string;
  modalType: "datamodelTable";
  type: "table";
  label: string;
  columns: IColumn[];
  dataUrl: IDataUrlPost;
  modalData?: { // Extra information the modal needs to edit this widget
    [index: string]: string;
  }
}

interface ITableWidgetProps {
  title: string;
  columns: IColumn[];
  dataUrl: IDataUrlPost;
  previewMode?: boolean;
}

const TableWidget = ({title, columns, dataUrl, previewMode}: ITableWidgetProps) => {
  return <div>
    <DataTable title={title} style="compact" defaultSortCol={columns[0].key} columns={columns} previewMode={previewMode} dataUrl={dataUrl} selectionMode="off"/>
  </div>;
};

export default TableWidget;